import routesLimited, { hasProperty } from '@/constants/routesLimited'
import { castRouteIds } from 'plugins/router/routes/castRouteIds'
import type { LimitedObject } from 'plugins/router/types'
import type { RouteRecordRaw } from 'vue-router'
import { aliases } from '../aliases'

const hasReviewDocuments: LimitedObject = {
	method: hasProperty,
	parameter: {
		store: 'user',
		getter: 'modules',
		property: 'review_documents',
		value: true,
	},
}
const reviewDocument: RouteRecordRaw = {
	children: [
		{
			name: 'reviewDocument',
			path: '',
			props: castRouteIds,
			component: () =>
				import('@/components/modules/ReviewDocuments/Reviewers.vue'),
		},
		{
			name: 'reviewDocumentNotifications',
			path: 'notifications',
			props: castRouteIds,
			component: () =>
				import('@/components/modules/ReviewDocuments/Notifications.vue'),
		},
		{
			name: 'reviewDocumentComments',
			path: 'comments',
			props: castRouteIds,
			component: () => import('@/components/modules/Comments/Comments.vue'),
		},
	],
	component: () =>
		import('@/components/modules/ReviewDocuments/ReviewDocumentItem.vue'),
	meta: {
		name: 'reviewDocument',
	},
	alias: aliases.review_document,
	path: ':reviewDocumentId',
	props: castRouteIds,
}
const reviewDocumentsList: RouteRecordRaw = {
	component: () =>
		import('@/components/modules/ReviewDocuments/ReviewDocumentList.vue'),
	name: 'reviewDocuments',
	path: '',
}
const reviewDocuments: RouteRecordRaw = {
	children: [
		reviewDocumentsList,
		reviewDocument,
		/*{
			path: ':reviewDocumentId/accounts/:accountId?',
			beforeEnter: (to, from, next) => {
				const { reviewDocumentId, accountId } = to.params

				if (accountId) {
					next({
						name: 'reviewDocument',
						params: { reviewDocumentId },
						query: { accountId },
					})
				} else {
					next({
						name: 'reviewDocument',
					}) // Proceed normally if no accountId is present
				}
			},
		},*/
	],
	component: () =>
		import('@/components/modules/ReviewDocuments/ReviewDocumentLayout.vue'),
	meta: {
		auth: true,
		icon: 'fa-fw fa-regular fa-magnifying-glass-dollar',
		name: 'reviewDocuments',
		nav: true,
		tour: true,
		ordering: 6,
		title: 'entity.review_document.name',
		subs: [routesLimited.subModules.review_documents],
		limited: [routesLimited.isAdminOrTeam, hasReviewDocuments],
	},
	path: '/review_documents',
	redirect: { name: 'reviewDocuments' },
}

export { reviewDocument, reviewDocuments }
